import React, { Component } from 'react';
import { Tabs } from 'antd';

import MainTabTab from './Menu';
import HomeMenuTab from '../HomePage/Tabs/Menu';
import FooterMenuTab from '../FooterMenu';

class MenuTabPage extends Component {
  render() {
    const { formItemLayout } = this.props;

    return (
      <Tabs defaultActiveKey="0">
        <Tabs.TabPane tab="Menu Chính" key="0">
          <MainTabTab />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Menu Trang Chủ" key="1">
          <HomeMenuTab formItemLayout={formItemLayout} />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Menu Chân Trang" key="2">
          <FooterMenuTab formItemLayout={formItemLayout} />
        </Tabs.TabPane>
      </Tabs>
    );
  }
}

export default MenuTabPage;



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Governance/Menu/MenuTab.js